import makeLogger from "../shared/lib/log";
import { Requester } from "./requester";

const logger = makeLogger("ai.roas.visitor");

export enum Event {
  Identify = "identify",
  Interactions = "interactions",
  Linger = "linger",
  PageLoad = "page-load",
  RRWeb = "rrweb",
}

export interface TrackData {
  vid?: string;
  sid?: string;
  xid?: string;
  event: Event;
  email?: string;
  hem?: string;
  fbp?: string;
  url: string;
  data?: Record<string, any>;
}

export interface Visitor {
  vid: string;
  sid: string;
  xid: string;
}

export const track = async (
  request: Requester,
  data: TrackData,
): Promise<Visitor> => {
  logger.debug("tracking", { data });
  const response = await request("pixel/visitors", {
    method: "POST",
    body: JSON.stringify(data),
  });
  return await response.json();
};
